import { FC, useState } from "react";
import {
  Box,
  Checkbox,
  Grid,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { ContractData, ContractUnit, SelectedSite } from "./Types";
import FormField from "../../../../../components/common/FormField";
import { CONTRACT_FORM_ELEMENTS } from "./contractsUtils";
import CustomButton from "../../../../../components/common/button/CustomButton";
import TableDesign, {
  TableHeading,
} from "../../../../../components/common/table/TableDesign";
import { StorageRow, UnitRow } from "./Types";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AlertPopup from "../../../../../components/common/alertPopup/AlertPopup";
import { deleteContractUnitAction } from "../../../../../store/reducers/contractStorageSlice";
import { useDispatch } from "react-redux";
const storageHeadings: TableHeading[] = [
  { label: "Storage Name", align: "left" },
  { label: "Storage Type", align: "left" },
  { label: "Units", align: "left" },
];

const unitHeadings: TableHeading[] = [
  { label: "Unit Name", align: "left" },
  { label: "Reference", align: "left" },
  { label: "Storage Size", align: "left" },
  { label: "Storage Type", align: "left" },
  { label: "In", align: "left" },
  { label: "Out", align: "left" },
  { label: "Provisional", align: "left" },
  { label: "Price & Duration", align: "left" },
  { label: "Action", align: "center" },
];

interface ContractDetailsStepProps {
  contractData: ContractData;
  onFieldChange: (field: keyof ContractData, value: string | boolean) => void;
  isFormReadyOnly?: boolean;
  errors?: Partial<Record<keyof ContractData, string>>;
  isNewContract?: boolean;
  selectedSites?: SelectedSite[];
  onSelectStorage?: () => void;
  selectedStorage?: any | null;
  selectedUnits?: UnitRow[];
  setSelectedSites?:any;
  onUnitChange?: (
    unitId: string,
    field: "inDate" | "outDate" | "provisional",
    value: string | boolean,
  ) => void;
  customerName?: string;
  checkValidator?: any;
  resetValidator?: any;
  error?: any;
}

const ContractDetailsStep: FC<ContractDetailsStepProps> = ({
  contractData,
  onFieldChange,
  isFormReadyOnly = false,
  errors = {},
  isNewContract = false,
  selectedSites = [],
  setSelectedSites,
  selectedStorage = null,
  selectedUnits = [],
  onUnitChange,
  onSelectStorage,
  customerName = "",
  checkValidator,
  resetValidator,
  error,
}) => {
  const formElements = CONTRACT_FORM_ELEMENTS(
    isNewContract,
    !!contractData?.useUnitsForInvoiceValue,
  );

  console.log("contractData",contractData);
  console.log("selectedSites",selectedSites);
  const [selectedUnitId, setSelectedUnitId] = useState<string | null>(null);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
  const dispatch = useDispatch();
  /** * Handle Contract Details form changes */
  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, name, value, checked, type } = event.target;
    const fieldId = (id || name) as keyof ContractData;
    onFieldChange(fieldId, type === "checkbox" ? checked : value);
  };

  /** * Total selected units from all sites. */
  const totalSelectedUnits = selectedSites.reduce(
    (total, site) => total + site.units.length,
    0,
  );
  const formatDateForInput = (date?: string) => {
    if (!date) {
      return "";
    }

    const datePart = date.match(/^\d{4}-\d{2}-\d{2}/)?.[0];
    if (datePart) {
      return datePart;
    }

    const parsedDate = new Date(date);
    return Number.isNaN(parsedDate.getTime())
      ? ""
      : parsedDate.toISOString().split("T")[0];
  };
  /** * Flatten all selected units from all sites.
   * * * This is only for displaying them in the table.
   * * The actual source of truth remains selectedSites. */
  const allSelectedUnits = selectedSites.flatMap((site) => site.units);
  console.log("allSelectedUnits", allSelectedUnits);
  const handleDeleteClick = (unitId: string) => {
    setSelectedUnitId(unitId);
    setDeleteAlertOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (!selectedUnitId) return;

    dispatch(
      deleteContractUnitAction({
        contractId: contractData?.id,
        unitId: selectedUnitId,
      }),
    );

    setDeleteAlertOpen(false);
    setSelectedUnitId(null);
  };

  const handleDeleteCancel = () => {
    setDeleteAlertOpen(false);
    setSelectedUnitId(null);
  };

const handleRemoveUnit = (unitId: string) => {
  setSelectedSites((prevSites:any) =>
    prevSites
      .map((site:any) => ({
        ...site,
        units: site.units.filter(
          (unit:any) => unit.unitId !== unitId
        ),
      }))
      .filter((site:any) => site.units.length > 0)
  );
};

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#E5F4F1",
          borderRadius: "5px",
          padding: "16px 20px",
        }}
      >
        <Grid container spacing={0.5}>
          {formElements?.map((field: any, i: number) => {
            const fieldId = field.id as keyof ContractData;

            return (
              <FormField
                key={field.id ?? i}
                {...field}
                name={field.id}
                minDate={
                  field.id === "endDate"
                    ? contractData.startDate || undefined
                    : field.minDate
                }
                value={
                  field.id === "customer_name"
                    ? customerName
                    : (contractData?.[fieldId] ?? "")
                }
                checked={
                  field.type === "checkbox"
                    ? !!contractData?.[fieldId]
                    : undefined
                }
                variant="outlined"
                onChange={onChangeAction}
                isNonMarginTop
                inSingleGridForm
                disabled={field?.id ==='isInsuranceAccepted' ? true : isFormReadyOnly || field?.editReadOnly}
                InputProps={{
                  ...(field?.inputProps || {}),
                  disabled: isFormReadyOnly || field?.editReadOnly,
                  sx:
                    field?.type === "text" || field?.type === "date"
                      ? {
                          height: field?.multiline ? "auto" : "36px",
                        }
                      : {
                          padding: "10px 4px",
                          height: "36px",
                        },
                }}
                error={!!error?.[fieldId]}
                // helperText={error?.[fieldId] || ""}
              />
            );
          })}
        </Grid>
      </Box>
      <Box
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: "5px",
          padding: "16px",
          mt: 2,
          fontSize: "13px",
          color: "#555",
        }}
      >
        Provisional (check box) — If checked, this means this is a provisional
        out of storage date. This means when the user looks at the list it will
        show that it might be available after this date. If not ticked, this is
        a confirmed out of storage date.
      </Box>
      {!isFormReadyOnly && (
        <Box sx={{ display: "flex", gap: 1.5, my: 2 }}>
          <CustomButton
            title="Select Storage"
            onClick={onSelectStorage}
            variant="outlined"
          />
        </Box>
      )}
      {/* ========================================================= SELECTED STORAGE / SITES ========================================================= */}
      {selectedSites.length > 0 && (
        <Box sx={{ mt: 2 }}>
          {/* ===================================================== SELECTED STORAGE TITLE ===================================================== */}
          <Box sx={{ fontSize: "16px", fontWeight: 700, mb: 1 }}>
            {" "}
            Selected Storage{" "}
          </Box>
          {/* ===================================================== STORAGE / SITE TABLE ===================================================== */}
          <TableDesign
            tableHeadings={storageHeadings}
            tableHeadColor="#02906f"
            cellColor="#fff"
            filterOption={null}
            setFilterOption={() => {}}
          >
            {" "}
            {selectedSites.map((site: SelectedSite) => (
              <TableRow key={site.siteId}>
                {" "}
                <TableCell> {site.siteName || "-"} </TableCell>{" "}
                <TableCell> {site.siteType || "-"} </TableCell>{" "}
                <TableCell> {site.units.length} Selected </TableCell>{" "}
              </TableRow>
            ))}{" "}
          </TableDesign>{" "}
          {/* ===================================================== SUMMARY ===================================================== */}{" "}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            {" "}
            <Typography
              sx={{ fontSize: "13px", fontWeight: 600, color: "#555" }}
            >
              {" "}
              {selectedSites.length} Storage Site{" "}
              {selectedSites.length !== 1 ? "s" : ""} / {totalSelectedUnits}{" "}
              Unit {totalSelectedUnits !== 1 ? "s" : ""} Selected{" "}
            </Typography>{" "}
          </Box>{" "}
          {/* ===================================================== SELECTED UNITS TITLE ===================================================== */}{" "}
          <Box sx={{ fontSize: "16px", fontWeight: 700, mt: 2, mb: 1 }}>
            {" "}
            Selected Units{" "}
          </Box>{" "}
          {/* ===================================================== SELECTED UNITS TABLE ===================================================== */}{" "}
          <TableDesign
            tableHeadings={unitHeadings}
            tableHeadColor="#02906f"
            cellColor="#fff"
            filterOption={null}
            setFilterOption={() => {}}
          >
            {" "}
            {allSelectedUnits.length > 0 ? (
              allSelectedUnits.map((unit: ContractUnit) => (
                <TableRow key={unit.unitId}>
                  {" "}
                  {/* Unit Name */}{" "}
                  <TableCell> {unit.unitTypeName || "-"} </TableCell>{" "}
                  {/* Reference */}{" "}
                  <TableCell> {unit.unitRefId || "-"} </TableCell> {/* Size */}{" "}
                  <TableCell>
                    {" "}
                    {unit.sizeFt3 ? `${unit.sizeFt3} ft³` : "-"}{" "}
                  </TableCell>{" "}
                  {/* Storage Type */}{" "}
                  <TableCell> {unit.storageType || "-"} </TableCell> {/* In */}{" "}
                  <TableCell>
                    <FormField
                      id={`inDate-${unit.unitId}`}
                      type="date"
                      value={formatDateForInput(unit.inDate)}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        onUnitChange?.(
                          unit.unitId,
                          "inDate",
                          event.target.value,
                        )
                      }
                      disabled={isFormReadyOnly}
                      InputProps={{ sx: { height: "30px" } }}
                    />
                  </TableCell>
                  {/* Out */}
                  <TableCell>
                    <FormField
                      id={`outDate-${unit.unitId}`}
                      type="date"
                      value={formatDateForInput(unit.outDate)}
                      minDate={formatDateForInput(unit?.inDate) || undefined}
                      maxDate={contractData?.endDate ? formatDateForInput(contractData?.endDate) : undefined}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        onUnitChange?.(
                          unit.unitId,
                          "outDate",
                          event.target.value,
                        )
                      }
                      disabled={isFormReadyOnly}
                      InputProps={{ sx: { height: "30px" } }}
                    />
                  </TableCell>
                  {/* Provisional */}{" "}
                  <TableCell>
                    <Checkbox
                      checked={Boolean(unit.provisional)}
                      disabled={isFormReadyOnly}
                      onChange={(event) =>
                        onUnitChange?.(
                          unit.unitId,
                          "provisional",
                          event.target.checked,
                        )
                      }
                      size="small"
                    />
                  </TableCell>{" "}
                  {/* Price & Duration */}{" "}
                  <TableCell>
                    {unit.pricePerUnit ? `${unit.pricePerUnit}` : "-"}
                    {unit.rentType ? ` / ${unit.rentType}` : ""}
                  </TableCell>{" "}
                  <TableCell align="center">
                    <IconButton
                      color="error"
                      size="small"
                      aria-label="Delete unit"
                      disabled={isFormReadyOnly}
                      onClick={() => contractData?.id ?  handleDeleteClick(unit.unitId) : handleRemoveUnit(unit.unitId) }
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                {" "}
                <TableCell colSpan={unitHeadings.length} align="center">
                  {" "}
                  No units selected.{" "}
                </TableCell>{" "}
              </TableRow>
            )}{" "}
          </TableDesign>{" "}
        </Box>
      )}{" "}
      {/* ========================================================= NO STORAGE SELECTED ========================================================= */}{" "}
      {selectedSites.length === 0 && (
        <Box
          sx={{
            border: "1px dashed #ccc",
            borderRadius: "5px",
            padding: "20px",
            mt: 2,
            textAlign: "center",
            color: "#777",
            fontSize: "14px",
          }}
        >
          {" "}
          No storage site or unit selected.{" "}
        </Box>
      )}

      {deleteAlertOpen && (
        <AlertPopup
          open={deleteAlertOpen}
          title="Delete Unit"
          content="Are you sure you want to delete this unit?"
          onHide={() => setDeleteAlertOpen(false)}
          submitHandler={handleDeleteConfirm}
          yesText="Yes"
          noText="No"
        />
      )}
    </>
  );
};

export default ContractDetailsStep;
